export function statusConfig({ colors }) {
    return {
        variant: {
            color: {
                error: colors.text.color,
                info: colors.text.color,
                success: colors.text.color,
                warning: colors.text.color
            },
            background: {
                info: "#d2e8fe",
                success: "#b4f0db",
                warning: "#fceccb",
                error: "#fbd0dd"
            }
        }
    };
}
